import { Component, Injectable, Input, ViewEncapsulation } from '@angular/core';
import { AddressViewModel, LocationNotificationSender } from '@core/api';

@Component({
  selector: 'app-telekom-email-template',
  templateUrl: './telekom-email-template.component.html',
  styleUrls: ['./telekom-email-template.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom,
  standalone: false,
})
@Injectable({
  providedIn: 'root',
})
export class TelekomEmailTemplateComponent {
  @Input() address: AddressViewModel;
  @Input() emailContent = '';
  @Input() subject = '';
  @Input() senderText = '';
  @Input() sender: LocationNotificationSender =
    LocationNotificationSender.TELEKOM;

  readonly senderTypes = LocationNotificationSender;

  date = new Date();
}
